import { useThree as D } from "@react-three/fiber";
import { memo as F, useMemo as x, useEffect as T } from "react";
import { RgView as E } from "../../3d/rg-render-types/index4.js";
import { mergeMeshes as _ } from "../../geometry-utils/three/index17.js";
import { useFunction as $ } from "../../hooks/index2.js";
import { getRgParentOfType as j } from "../../utils/rg-util/index4.js";
import { ChildrenToMerge as B } from "./index4.js";
import { applyBoxUV as N } from "../../utils/internal/index.js";
import { jsx as O, Fragment as P } from "react/jsx-runtime";
const S = F(({
  objs: s,
  parent: R,
  layer: t,
  visibility: n,
  colourFunc: a,
  addUVs: c = !1,
  onClick: d,
  onContextMenu: p,
  onDoubleClick: v,
  onPointerUp: f,
  onPointerDown: g,
  onPointerOver: l,
  onPointerOut: u,
  onPointerEnter: h,
  onPointerLeave: M,
  onPointerMove: w,
  onPointerCancel: b
}) => {
  const o = x(() => {
    const e = new E({
      ...R,
      children: s
    });
    return e.removeMesh(), e;
  }, [s]), m = x(() => {
    for (const r of o.rgChildren)
      t.cancel && t.cancel(r.userData) ? r.setVisibility({
        visibility: []
      }) : r.setVisibility({
        visibility: n,
        visible: t.visible
      });
    o.updateWorldMatrix(!1, !0), o.updateColour(a);
    const e = _(o);
    return c && N(e), e;
  }, [o, n, t, a, c]), V = D((e) => e.raycaster), i = $((e, r) => {
    e.timeStamp = Date.now(), o.setVisibility({
      visibility: n,
      visible: t.visible
    });
    const C = V.intersectObject(o), y = j(C[0].object.view.userData, B);
    r({
      event: e,
      obj: y,
      intersections: C
    });
  });
  return T(() => () => m.dispose(), [m]), o.activeMeshes ? /* @__PURE__ */ O("mesh", {
    name: `merged-${s[0].type}-${s.length}`,
    position: o.position,
    rotation: o.rotation,
    geometry: m,
    material: t.material,
    renderOrder: t.renderOrder,
    onClick: d ? (e) => i(e, d) : void 0,
    onContextMenu: p ? (e) => i(e, p) : void 0,
    onDoubleClick: v ? (e) => i(e, v) : void 0,
    onPointerUp: f ? (e) => i(e, f) : void 0,
    onPointerDown: g ? (e) => i(e, g) : void 0,
    onPointerOver: l ? (e) => i(e, l) : void 0,
    onPointerOut: u ? (e) => i(e, u) : void 0,
    onPointerEnter: h ? (e) => i(e, h) : void 0,
    onPointerLeave: M ? (e) => i(e, M) : void 0,
    onPointerMove: w ? (e) => i(e, w) : void 0,
    onPointerCancel: b ? (e) => i(e, b) : void 0
  }) : /* @__PURE__ */ O(P, {});
});
S.displayName = "RgMergeFC";
export {
  S as RgMergeFC
};
//# sourceMappingURL=index6.js.map
